import React, { createContext } from 'react'
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { arbitrum, mainnet, polygon, skaleNebula } from 'wagmi/chains'
import { walletConnectProjectId } from '../../config'

const chains = [arbitrum, mainnet, skaleNebula]
const projectId = walletConnectProjectId

export const Web3Context = createContext()

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)

export const Web3Provider = ({ children }) => {
  return (
    <Web3Context.Provider value={{ ethereumClient, projectId }}>
      <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>
    </Web3Context.Provider>
  )
}
